/*
* @Author: yongwenhao
* @Date: 2020-04-07 11:35:22
* @describe: 临床运营
*/
<template>
    <ItemWarp :dataInfo="dataInfo"></ItemWarp>
</template>

<script>
    import serviceData from '../../js/data'
    import ItemWarp from './components/item-warp'

    export default {
        name: "dm",
        props: {},
        components: {ItemWarp},
        data() {
            return {
                dataInfo: serviceData.dm
            }
        }
    }
</script>

<style lang='less' scoped>
/deep/ .info-content {
    max-width: 520px;
}
</style>